import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  zoneCount: number;
}

export const ConfirmDeleteAllModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  zoneCount,
}) => {

  return (
    <Modal
      title={"Confirm Deletion of All Rock Types"}
      open={isOpen}
      onOk={onConfirm}
      onCancel={onClose}
      okText={"Delete All"}
      cancelText={"Cancel"}
      okType='danger'
    >
      <p>
        Are you sure you want to delete all {zoneCount} zones? 
        This action cannot be undone.
      </p>
    </Modal>
  );
};